module.exports = __webpack_public_path__ + "static/media/buildSummaryHover.6cb136fc.svg";